import { useQuery } from '@tanstack/react-query';
import cx from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { FunctionComponent } from 'react';

import useLinkProps from '../../../hooks/use-link-props';
import getLoggedUser from '../../../utils/react-query/query-options/get-logged-user';
import Breadcrumbs from '../../modules/v2/breadcrumbs';
import PageTitle from '../../ui/typography/page-title';

import SignUpForm from './form';
import HelpInfo from './help-info';
import SignupSchema from './seo';
import Link from 'next/link';
import BPImage from '../../ui/v2/image';
import BPartsBicon from '../../ui/icons/bparts-b-icon';
import Chevrelon from '../../ui/icons/cheverlon';
import BPartsPurchaseInfo from '../product/b-parts-purchase-info';
import HelpCheckout from '../../modules/help/help-checkout';

const SignupPage: FunctionComponent<TPageRegister> = () => {
  const { t } = useTranslation();
  const getLink = useLinkProps();
  const { locale = 'en', push } = useRouter();
  const { data: user, isLoading } = useQuery(...getLoggedUser({ locale }), {
    refetchOnMount: true,
    keepPreviousData: true,
    onSuccess: (data) => {
      if (data) {
        const link = getLink('private-area');
        push(link.href, link.as);
      }
    },
  });
  const proRegisterLink = getLink('login');

  if (isLoading || user) {
    // TODO - loading page
    return (
      <main className="flex w-full h-full justify-center items-center">
        loading...
      </main>
    );
  } else {
    return (
      <main>
        <SignupSchema breadcrumbs={[]} />
        <Breadcrumbs items={[]} currentPage={t('signup:signup')} />

        <div
          className={cx(
            'container mx-auto grid grid-cols-1 lg:grid-cols-[2fr_1fr] gap-6 lg:gap-28 px-4 pt-6 lg:py-12'
          )}
        >
          <div className={cx()}>
            <div className={cx('lg:col-span-2')}>
              <div className="">
                <PageTitle
                  title={t('signup:signup')}
                  subtitle={t('signup:detail')}
                />
              </div>
              <SignUpForm />
            </div>
          </div>
          <div>
            <div className='mb-4'>
              <Link {...proRegisterLink
              } className='group' >
                <div className={cx('w-full relative bg-white shadow border-neutral-10')}>
                  <BPImage
                    src={'/svg/banner-pa-bg.svg'}
                    alt="image_bg_pa"
                    fill={true}
                    sizes="100%"
                    className="object-cover object-[20px_-30px]"
                    quality={100}
                  />
                  <div className={cx('relative w-full container mx-auto flex flex-col gap-3', 'p-4')}>
                    <div className='flex flex-row justify-between items-center gap-2'>
                      <span className='font-bold group-hover:text-neutral-50'>{t('signup:have-account')}</span>
                      <BPartsBicon className='h-8 group-hover:text-neutral-50'></BPartsBicon>
                    </div>
                    <div className='flex flex-row justify-between items-center gap-2'>
                      <span className='text-sm group-hover:text-neutral-50'>{t('signup:login-account')}</span>
                      <Chevrelon className='h-4 group-hover:text-neutral-50 -rotate-90' />
                    </div>
                  </div>
                </div>
              </Link >
            </div>

            <div className='bg-brand-10 h-fit max-lg:mb-8'>
              <BPartsPurchaseInfo
                productDetail={[]}
                isGeneric
              >
              </BPartsPurchaseInfo>
              <div className='px-4 pb-4'>
                <HelpCheckout></HelpCheckout>
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }
};

export default SignupPage;
